export default __webpack_public_path__ + "de05d57603caa70a27d5a00ddb73faec.svg";